import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import { IMapPath } from "../../../models/storeModels/maps/IMapPath";

function getInitialState() {
    const initialState: IMapPath = {
        mapPathValue: null,
        mapPathPosition: null,
        mapPathEnding: null
    }
    return initialState;
}

export const mapPathSlice = createSlice({
    name: 'mapPath',
    initialState: getInitialState(),
    reducers: {
        setMapPathValue(state, action: PayloadAction<any>) {
            state.mapPathValue = action.payload
        },
        setMapPathPosition(state, action: PayloadAction<any>) {
            state.mapPathPosition = action.payload
        },
        setMapPathEnding(state, action: PayloadAction<any>) {
            state.mapPathEnding = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setMapPathEnding, setMapPathPosition, setMapPathValue } = mapPathSlice.actions;
export const mapPathReducer = mapPathSlice.reducer;